import { useEffect } from 'react';
import { initializeCustomerio } from '../../utils';

interface UseCustomerioIntegrationWithConfigProps {
  enable?: boolean;
  onError?: (error: any) => void;
}

const useCustomerioIntegrationWithConfig = ({
  enable = true,
  onError,
}: UseCustomerioIntegrationWithConfigProps = {}) => {
  const siteId = process.env.REACT_APP_CUSTOMERIO_SITE_ID;

  useEffect(() => {
    if (!enable) return;

    try {
      if (siteId) {
        initializeCustomerio(siteId);
      }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.error('Error initializing Customer.io:', error);
      }
      onError?.(error);
    }
  }, [enable, siteId, onError]);

  return null;
};

export default useCustomerioIntegrationWithConfig;
